<template lang="pug">
  .header(:class="{ bg_black: $route.path !== '/',fixed: scroll200}")
    nav.navbar.navbar-landing-pc.navbar-client-pc.navbar-expand-lg.navbar-light.wak-navbar.d-flex.justify-content-between.w-md-auto(:class="{ bg_black: navbarOpen}")
      .flex
        .left
          | <!--dummy-->
        .center
          router-link.navbar-brand(
            :to={name: 'home.index'})
            img(
              src="../../../assets/images/logo_sp.svg"
              :alt="$t('header.logo')")
        .right
          button.navbar-toggler(
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            :class="{'collapsed': !navbarOpen}"
          )
            span.icon_close.close( @click="closeMenu")
            span.navbar-toggler-icon.icon_menu( @click="openMenu")

      #navbarSupportedContent.collapse.navbar-collapse(
        v-if="navbarOpen"
      )
        .member-btn
          a(href="https://members.zatsudan.com/auth/login" target="_blank" class="menber-login")
           | ログイン
          a(href="https://members.zatsudan.com/auth/verify-email" target="_blank" class="menber-register")
           | アカウント登録
        ul.navbar-nav.ml-auto
          li.nav-item(v-if="!isAfter(date_now, show_twitter)")
            router-link.nav-link.text-white(
              @click="toggleMenu"
              :to={name: 'usage.index'})
              | {{$t('header.usage')}}
          li.nav-item
            router-link.nav-link.text-white(
              @click="toggleMenu"
              :to={name: 'streamer.index'})
              | {{$t('header.streamer')}}
          li.nav-item
            router-link.nav-link.text-white(
              @click="toggleMenu"
              :to={name: 'news.index'})
              | {{$t('header.news')}}
          li.nav-item
            router-link.nav-link.text-white(
              @click="toggleMenu"
              :to={name: 'faq.index'})
              | {{$t('header.faq')}}
        .appstore
          ul.appstore-list
            li.appstore-item
              a(href="https://apps.apple.com/us/app/zatsudan/id1542757006" target="_blank")
                img(src="../../../assets/images/ios-stroe.png" alt="ios")
            li.appstore-item
              a(href="https://play.google.com/store/apps/details?id=net.zatsudan.prod" target="_blank")
                img(src="../../../assets/images/google-play.png" alt="android")


        .share
          .share-list
            .share-item
              a(href="https://lin.ee/ht7AKDg" target="_blank")
                img(src="../../../assets/images/line-icon.svg" alt="line")
            .share-item
              a(href="https://twitter.com/ZATSUDAN_JP" target="_blank")
                img(src="../../../assets/images/twitter-icon.svg" alt="twitter")





</template>
<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'header-index-sp',
    computed: {
      ...mapGetters('layout', ['navbarOpen', 'scroll200']),
    },
    data() {
      return {
        date_now: this.$moment().format(),
        show_twitter: this.$moment('2021-01-31T23:59:59+09:00').format(),
      }
    },
    methods: {
      ...mapActions('layout', ['setNavbarOpen']),
      toggleMenu() {
        this.setNavbarOpen(!this.navbarOpen)
      },
      openMenu() {
        this.setNavbarOpen(true)
      },
      closeMenu() {
        this.setNavbarOpen(false)
      },
      isAfter(dateNow, endDate) {
        //console.log(this.$moment(dateNow))
        return this.$route.query.time ? this.$moment(this.$route.query.time).isAfter(endDate) : this.$moment(dateNow).isAfter(endDate)
      }
    },
  }
</script>
